import { render, staticRenderFns } from "./freezealert.vue?vue&type=template&id=0abc6aee"
import script from "./freezealert.vue?vue&type=script&lang=js"
export * from "./freezealert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports